import {
  CaretDownOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Avatar, Breadcrumb, Dropdown, Menu, Space, Tag } from "antd";
import { Header } from "antd/es/layout/layout";
import clsx from "clsx";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { userStore } from "store/userStore";
import { formatVND } from "utils";
import { $url } from "utils/url";

const userMenu = (
  <Menu>
    <Menu.Item key="login">
      <Link to="/login" onClick={() => userStore.logout()}>
        Đăng xuất
      </Link>
    </Menu.Item>
  </Menu>
);

type NavbarProps = {
  collapsed: boolean;
  toggle: () => void;
  isMobile?: boolean;
};

export const Navbar = observer(
  ({ collapsed, toggle, isMobile = false }: NavbarProps) => {
    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);

    useEffect(() => {
      const find = adminRoutes.find((e) => e.path == location.pathname);
      if (find) {
        if (find.breadcrumb) {
          setBreadcrumbs(find.breadcrumb.split("/"));
        } else if (find.title) {
          setBreadcrumbs([find.title]);
        }
      }
    }, [location.pathname]);

    const showMenuIcon = isMobile || collapsed;

    return (
      <Header
        className={clsx(
          "site-layout-background admin-navbar",
          collapsed && "collapsed",
          isMobile && "admin-navbar--mobile",
        )}
      >
        <div className="admin-navbar__left">
          {React.createElement(
            showMenuIcon ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
            },
          )}
          <Breadcrumb
            className={clsx(
              "admin-navbar__breadcrumb",
              !collapsed && !isMobile && "mobile-breadcrumb-none",
            )}
          >
            {breadcrumbs.map((item, i) => (
              <Breadcrumb.Item key={i} className="font-semibold">
                {item}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>

        <Space className="admin-navbar__actions" size={20}>
          <span className="admin-navbar__version">v{settings.version}</span>

          {userStore?.info?.area && (
            <Tag color="blue" className="admin-navbar__balance-tag">
              <span className="admin-navbar__balance-name">
                {userStore?.info?.area?.name}
              </span>
              <Link className="tooltip-text admin-navbar__balance-link" to="/transaction-area">
                Số dư:{" "}
                <span className="admin-navbar__balance-amount">
                  {formatVND(userStore?.info?.area?.balance || 0)}đ
                </span>
              </Link>
            </Tag>
          )}

          <Dropdown trigger={["click"]} overlay={userMenu}>
            <Space className="admin-navbar__user">
              <Avatar
                size="large"
                src={$url(userStore.info.avatar)}
                className="admin-navbar__avatar"
              >
                {userStore.info.name?.[0]}
              </Avatar>
              <CaretDownOutlined className="admin-navbar__caret" />
            </Space>
          </Dropdown>
        </Space>
      </Header>
    );
  },
);
